module.exports = __webpack_public_path__ + "img/Group 23.0c114d7c.svg";